export default __webpack_public_path__ + "static/media/palm-tree.8969ff7e.png";